import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesOffers } from "../../constants";
import {
  UpdateOfferBody,
  UpdateOfferResponse
} from "./updateSpecialOffer.types";

export const requestUpdateSpecialOffer = async ({
  id,
  body
}: UpdateOfferBody): Promise<UpdateOfferResponse> => {
  return await instance.patch(
    buildUrl(ApiRoutesOffers.SpecialOffers, id),
    body
  );
};
